<nav sidebar id="sidebar" role="navigation" class="sidebar"></nav>
<nav navbar (toggleSidebarEvent)="toggleSidebarListener($event)" class="page-controls navbar navbar-dashboard"></nav>
<aside chat-sidebar class="chat-sidebar"></aside>

<div class="content-wrap" id="content-wrap">
  
  <main id="content" class="content" role="main">
    <router-outlet></router-outlet>
  </main>
  <dynamic-modal [componentData]='componentData'></dynamic-modal>
</div>